export default __webpack_public_path__ + "static/ClarityNuvo-Light-2dc7f8937a531d93a56507ddc69c09cf.woff";